var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	19427: {
		fallback: () => (Promise.all([__webpack_require__.e(141), __webpack_require__.e(340)]).then(() => (() => (__webpack_require__(31340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	36831: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(427), __webpack_require__.e(260), __webpack_require__.e(76), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(49460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	56484: {
		fallback: () => (Promise.all([__webpack_require__.e(417), __webpack_require__.e(689), __webpack_require__.e(72)]).then(() => (() => (__webpack_require__(8072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	99689: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(427), __webpack_require__.e(613)]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	44803: {
		fallback: () => (__webpack_require__.e(645).then(() => (() => (__webpack_require__(49645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.11.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",

	},
	97250: {
		fallback: () => (__webpack_require__.e(227).then(() => (() => (__webpack_require__(46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	85555: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(417), __webpack_require__.e(456)]).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	34842: {
		fallback: () => (__webpack_require__.e(133).then(() => (() => (__webpack_require__(55133))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.2.0-rc.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@baylaurel/baylaurel-entities",

	},
	26876: {
		fallback: () => (__webpack_require__.e(534).then(() => (() => (__webpack_require__(68534))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "cron-validate",

	},
	68153: {
		fallback: () => (__webpack_require__.e(759).then(() => (() => (__webpack_require__(5759))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.4.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "zod",

	},
	20277: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(417), __webpack_require__.e(484), __webpack_require__.e(415)]).then(() => (() => (__webpack_require__(17415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	48767: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(260), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	68597: {
		fallback: () => (Promise.all([__webpack_require__.e(368), __webpack_require__.e(897), __webpack_require__.e(127), __webpack_require__.e(859)]).then(() => (() => (__webpack_require__(62859))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-combofun/utility/angular",

	},
	30461: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(417), __webpack_require__.e(484), __webpack_require__.e(689), __webpack_require__.e(767), __webpack_require__.e(270)]).then(() => (() => (__webpack_require__(5270))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@pathos/pathoslogos-ui",

	},
	12377: {
		fallback: () => (Promise.all([__webpack_require__.e(417), __webpack_require__.e(368), __webpack_require__.e(897), __webpack_require__.e(925)]).then(() => (() => (__webpack_require__(80925))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-combofun/shared",

	},
	77399: {
		fallback: () => (Promise.all([__webpack_require__.e(141), __webpack_require__.e(620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	41887: {
		fallback: () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	4219: {
		fallback: () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	4417: {
		fallback: () => (Promise.all([__webpack_require__.e(427), __webpack_require__.e(352)]).then(() => (() => (__webpack_require__(21352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	72987: {
		fallback: () => (Promise.all([__webpack_require__.e(552), __webpack_require__.e(457)]).then(() => (() => (__webpack_require__(24457))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/auth",

	},
	44539: {
		fallback: () => (Promise.all([__webpack_require__.e(552), __webpack_require__.e(725)]).then(() => (() => (__webpack_require__(36725))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/app",

	},
	52867: {
		fallback: () => (Promise.all([__webpack_require__.e(552), __webpack_require__.e(987)]).then(() => (() => (__webpack_require__(60987))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/functions",

	},
	92605: {
		fallback: () => (__webpack_require__.e(317).then(() => (() => (__webpack_require__(30698))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "encoding-japanese",

	},
	22087: {
		fallback: () => (__webpack_require__.e(841).then(() => (() => (__webpack_require__(85841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	},
	29574: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(50659))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxfire/auth",

	},
	46127: {
		fallback: () => (Promise.all([__webpack_require__.e(552), __webpack_require__.e(311)]).then(() => (() => (__webpack_require__(36311))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/firestore",

	},
	12075: {
		fallback: () => (Promise.all([__webpack_require__.e(552), __webpack_require__.e(639)]).then(() => (() => (__webpack_require__(40639))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/storage",

	},
	15704: {
		fallback: () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(12484))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxfire/firestore",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"127": [
		46127
	],
	"260": [
		41887,
		4219
	],
	"277": [
		20277
	],
	"368": [
		72987
	],
	"399": [
		77399
	],
	"417": [
		4417
	],
	"427": [
		19427
	],
	"484": [
		56484
	],
	"508": [
		12377
	],
	"555": [
		85555
	],
	"689": [
		99689
	],
	"767": [
		48767
	],
	"782": [
		34842,
		26876,
		68153
	],
	"831": [
		36831
	],
	"859": [
		12075,
		15704
	],
	"876": [
		44803,
		97250
	],
	"897": [
		44539,
		52867
	],
	"925": [
		92605,
		22087,
		29574
	],
	"953": [
		68597,
		30461
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}